import lottie from 'lottie-web';
import { defineElement } from 'lord-icon-element';
import Logo from '../../components/ui/Logo';
import FullPageBackground from '../../components/Full_Page_Background';
import { Colors } from '../../components/theme';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

defineElement(lottie.loadAnimation);

const ContentStyle = {
    width:'80%',
    maxWidth:'550px',
    textAlign:'center'
}

const LogoStyle = {
    maxWidth: '150px',
    width:'100%',
    margin: '55px auto',
    display: 'block'
}

export default function SuccessRegister() {
    const { t } = useTranslation();
    return (
        <>
            <div className='verti-hori-center' style={ContentStyle}>
                <lord-icon
                    src="https://cdn.lordicon.com/lupuorrc.json"
                    trigger="loop"
                    delay="5000"
                    colors="primary:#b41f23,secondary:#ccad61"
                    style={{width:'230px',height:'230px'}}>
                </lord-icon>

                <h1 className="underline">
                    {t("registration.success_page.title")}
                </h1>

                <p>
                    {t("registration.success_page.description")}
                </p>

                <Link to={"/login"}>
                    <Logo styling={LogoStyle}/>
                </Link>
            </div>

            <FullPageBackground
                bgColor={Colors.mediumBG}
            />
        </>
    )
}